module.exports = __webpack_public_path__ + "img/ok.cb88ea31.svg";